import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-features',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './features.component.html',
  styleUrl: './features.component.scss',
  host: { id: 'app-features-main' },
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(20px)',
        }),
        animate(
          '600ms ease-out',
          style({
            opacity: 1,
            transform: 'translateY(0)',
          })
        ),
      ]),
    ]),
    trigger('scaleIn', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'scale(0.9)',
        }),
        animate(
          '500ms ease-out',
          style({
            opacity: 1,
            transform: 'scale(1)',
          })
        ),
      ]),
    ]),
  ],
})
export class FeaturesComponent {
  featureBlocks = [
    {
      key: 'core',
      title: 'features.page.blocks.core.title',
      description: 'features.page.blocks.core.description',
      image: '/assets/images/features/core-features.jpeg',
      features: 'features.page.blocks.core.features',
    },

    {
      key: 'advanced',
      title: 'features.page.blocks.advanced.title',
      description: 'features.page.blocks.advanced.description',
      image: '/assets/images/features/advanced-features.jpeg',
      features: 'features.page.blocks.advanced.features',
    },
    {
      key: 'applications',
      title: 'features.page.blocks.applications.title',
      description: 'features.page.blocks.applications.description',
      image: '/assets/images/features/applications.jpeg',
      features: 'features.page.blocks.applications.features',
    },
  ];

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img) {
      img.style.display = 'none';
    }
  }

  onImageLoad(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img) {
      img.style.opacity = '1';
    }
  }
}
